import React from "react";
import { motion } from "framer-motion";
import { ArrowDown, ChevronDown } from "lucide-react";
import { ASSETS } from "@/data/siteContent";

export default function Hero({ onBookConsultation }) {
  const scrollToServices = (e) => {
    e.preventDefault();
    document.querySelector("#services")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full flex items-center overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center scale-105"
        style={{ backgroundImage: `url(${ASSETS.heroBg})` }}
        aria-hidden
      />
      <div className="absolute inset-0 bg-gradient-to-br from-navy-dark/92 via-navy/80 to-navy-dark/90" aria-hidden />
      <div className="absolute inset-0 grain-overlay" aria-hidden />

      <div className="relative container-prose pt-32 pb-20 md:pt-40 md:pb-28">
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="text-xs md:text-sm uppercase tracking-[0.25em] font-bold text-white mb-6"
          data-testid="hero-eyebrow"
        >
          — India's Premier Sports & Education Consultancy
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          className="font-serif text-white text-5xl md:text-6xl lg:text-7xl xl:text-[5.5rem] leading-[1.02] tracking-tight max-w-5xl text-balance"
          data-testid="hero-headline"
        >
          Navigating Your <span className="italic text-gold">Success</span><br className="hidden md:block" /> Starts Here.
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.45 }}
          className="mt-7 max-w-2xl text-white/85 text-lg md:text-xl font-sans leading-relaxed"
          data-testid="hero-subheadline"
        >
          India's Leading Sports & Education Consultancy — Turning Ambition Into Admission.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.65 }}
          className="mt-10 flex flex-col sm:flex-row gap-4"
        >
          <button
            data-testid="hero-explore-services"
            onClick={scrollToServices}
            className="group inline-flex items-center justify-center gap-2 bg-gold text-navy font-semibold px-7 py-4 text-sm tracking-wide uppercase rounded-sm hover:bg-gold-hover transition-all shadow-[0_18px_40px_-18px_rgba(245,197,24,0.7)] hover:shadow-[0_22px_50px_-18px_rgba(245,197,24,0.8)]"
          >
            Explore Our Services
            <ArrowDown size={16} className="group-hover:translate-y-0.5 transition-transform" />
          </button>
          <button
            data-testid="hero-book-consultation"
            onClick={onBookConsultation}
            className="inline-flex items-center justify-center gap-2 border border-white/60 text-white font-semibold px-7 py-4 text-sm tracking-wide uppercase rounded-sm hover:bg-white hover:text-navy transition-all"
          >
            Book a Free Consultation
          </button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.2, delay: 1 }}
          className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center text-white/70"
        >
          <span className="text-[10px] tracking-[0.4em] uppercase mb-2">Scroll</span>
          <motion.div
            animate={{ y: [0, 8, 0] }}
            transition={{ duration: 1.6, repeat: Infinity, ease: "easeInOut" }}
          >
            <ChevronDown size={22} />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
